module.exports = __webpack_public_path__ + "static/media/cap3-02-desk.8b4911bb.jpg";